export default __webpack_public_path__ + "static/media/math-fractions-blue.1c185bab.svg";